import { captureException } from '@sentry/browser';
import { trackEvent } from 'iclinic-trackings';

import { EVENT_TRACKING } from '../constants';

export type UserData = {
  profileId: string | null;
  isSubscriber?: boolean | null;
};

type DonwsellConfirmationTrackData = {
  userData: {
    profileId: string | null;
    isSubscriber?: boolean | null;
  };
  stepName: string;
  stepNum: number;
  failureReason?: string | null;
};

type DownsellReasonTrackData = {
  userData: {
    profileId: string | null;
    isSubscriber?: boolean | null;
  };
  stepName: string;
  stepNum: number;
  stepValue?: string | null;
};

const sendDownsellConfirmation = async ({
  userData,
  stepName,
  stepNum,
  failureReason = null,
}: DonwsellConfirmationTrackData) => {
  if (!userData?.profileId) return;

  await trackEvent('downsell_confirmation', {
    iclinic_id: Number(userData.profileId),
    app_id: EVENT_TRACKING.appId,
    app_feature: EVENT_TRACKING.appFeature,
    step_name: stepName,
    step_num: stepNum,
    failure_reason: failureReason,
  });
};

export const trackDownsellConfirmation = (
  params: DonwsellConfirmationTrackData,
): void => {
  sendDownsellConfirmation(params).catch((error) => {
    captureException(error);
  });
};

const sendDownsellReason = async ({
  userData,
  stepName,
  stepNum,
  stepValue = null,
}: DownsellReasonTrackData) => {
  if (!userData?.profileId) return;

  await trackEvent('downsell_reason', {
    iclinic_id: Number(userData.profileId),
    app_id: EVENT_TRACKING.appId,
    app_feature: EVENT_TRACKING.appFeature,
    step_name: stepName,
    step_num: stepNum,
    step_value: stepValue,
  });
};

export const trackDownsellReason = (params: DownsellReasonTrackData): void => {
  sendDownsellReason(params).catch((error) => {
    captureException(error);
  });
};
